import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Sparkles } from 'lucide-react';

import { useTranslation } from '@sshop/i18n';
import { cn, Container } from '@sshop/ui';

import { useLocale } from '@/shared/hooks/useLocale';
import { routes } from '@/shared/lib/routes';
import { ThemeToggle } from '@/shared/ui/ThemeToggle';

import { AccountMenu } from '../AccountMenu';

import { Brand } from './Brand/Brand';
import { CartButton } from './CartButton';
import { CmsPagesMenu } from './CmsPagesMenu';
import { CategoriesDesktopMenu, CategoriesMobileMenu } from './CategoriesMenu';
import { CompareButton } from './CompareButton';
import { HeaderSearch } from './HeaderSearch/HeaderSearch';
import { LanguageSwitcher } from './LanguageSwitcher';
import { WishlistButton } from './WishlistButton';
import { headerStyles as s } from './Header.styles';

export function Header() {
  const { t } = useTranslation();
  const locale = useLocale();
  const [searchFocused, setSearchFocused] = useState(false);
  return (
    <header className={s.root}>
      <Container className={s.container}>
        <Link to={routes.home(locale)} className={s.brand} aria-label={t('app.homeAria')}>
          <Brand />
        </Link>

        <div className={s.actions}>
          <Link
            to={routes.catalog(locale)}
            className={s.iconButton}
            aria-label={t('nav.allProducts')}
          >
            <ShoppingBag className={s.iconGlyph} aria-hidden />
          </Link>
          <CartButton />
          <div className={s.actionsCompare}>
            <CompareButton />
          </div>
          <div className={s.wishlistAction}>
            <WishlistButton />
          </div>
          <div className={s.desktopAction}>
            <ThemeToggle />
          </div>
          <div className={s.desktopAction}>
            <LanguageSwitcher />
          </div>
          <div className={s.divider} aria-hidden />
          <AccountMenu />
        </div>

        <div className={s.search}>
          <nav className={s.nav} aria-label={t('app.primaryNavigationAria')}>
            <CategoriesMobileMenu compact={searchFocused} />
            <CategoriesDesktopMenu compact={searchFocused} />
            <CmsPagesMenu />
            <Link
              to={routes.special(locale)}
              className={cn(s.navLink, searchFocused && s.navLinkFocused)}
              aria-label={t('nav.deals')}
            >
              <Sparkles className="h-4 w-4 shrink-0" aria-hidden />
              <span className={cn(s.navLabel, searchFocused && s.navLabelCollapsed)}>
                {t('nav.deals')}
              </span>
            </Link>
            <div className={cn(s.mobileCompare, searchFocused && s.mobileCompareFocused)}>
              <CompareButton />
            </div>
          </nav>
          <div className={cn(s.searchField, searchFocused && s.searchFieldFocused)}>
            <HeaderSearch onFocusChange={setSearchFocused} />
          </div>
        </div>
      </Container>
    </header>
  );
}
